import { MHColours } from '../../constants/theme';

// From the video visit design handoff (EASE2-603). The only red is hang-up;
// warnings use Dawn.
export const DS = {
  linen: '#F1EDE6',
  softBlack: '#242829',
  muted: '#5A5E5F',
  deepTeal: MHColours.mhDeepTeal,
  freshTeal: '#06A39D',
  mint: '#CAE9E4',
  dawn: '#EBB194',
  dawnSurface: 'rgba(235,177,148,.28)',
  hangUp: '#B8493E',
  surfaceTint: '#E7E2D9',
  lineSoft: 'rgba(36,40,41,.1)',
  lineStrong: 'rgba(36,40,41,.24)',
  stage: '#1C2021',
  frame: 'linear-gradient(170deg, #43484A, #2C3031)',
  selfTile: '#3A3E3F',
  selfBorder: 'rgba(241,237,230,.15)',
  pill: 'rgba(14,22,20,.72)',
  pillStrong: 'rgba(14,22,20,.82)',
  onDarkBorder: 'rgba(241,237,230,.5)',
  onDarkMuted: 'rgba(241,237,230,.8)',
  letterbox: '#000000',
  card: '#FFFFFF',
  cardWeak: '#F6E6DC',
  barEmpty: 'rgba(36,40,41,.18)',
  onDarkLabel: 'rgba(241,237,230,.85)',
  labelScrim: 'linear-gradient(to top, rgba(36,40,41,.6), transparent)',
  fontDisplay: '"Mona Sans", "Inter", system-ui, sans-serif',
  fontBody: '"Lato", "Helvetica Neue", system-ui, sans-serif',
  easeOutSoft: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
};

export const fadeInSx = {
  '@keyframes videoVisitFadeIn': {
    from: { opacity: 0, transform: 'translateY(6px)' },
    to: { opacity: 1, transform: 'none' },
  },
  animation: `videoVisitFadeIn 320ms ${DS.easeOutSoft}`,
  '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
};

export const overlayButtonSx = {
  height: 46,
  px: '20px',
  borderRadius: '999px',
  fontFamily: DS.fontBody,
  fontWeight: 700,
  fontSize: 13.5,
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  '&:focus-visible': {
    outline: `2px solid ${DS.freshTeal}`,
    outlineOffset: '3px',
  },
};

export const controlButtonSx = {
  height: 52,
  display: 'inline-flex',
  alignItems: 'center',
  gap: 1,
  borderRadius: '999px',
  fontFamily: DS.fontBody,
  fontWeight: 700,
  fontSize: 14,
  letterSpacing: '0.05em',
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  transition: `background-color 200ms ${DS.easeOutSoft}`,
  '&:focus-visible': {
    outline: `2px solid ${DS.freshTeal}`,
    outlineOffset: '3px',
  },
  '& svg': { fontSize: 20 },
};

export const outlinedControlButtonSx = {
  ...controlButtonSx,
  px: '18px',
  justifyContent: 'center',
  border: `1px solid ${DS.lineStrong}`,
  bgcolor: 'transparent',
  color: DS.softBlack,
  '&:hover': { bgcolor: DS.surfaceTint },
};
